import { render, staticRenderFns } from "./NeoparentMagicLinkError.vue?vue&type=template&id=ffd79260&scoped=true"
import script from "./NeoparentMagicLinkError.vue?vue&type=script&lang=js"
export * from "./NeoparentMagicLinkError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd79260",
  null
  
)

export default component.exports